(function () {
  if (window.SusucarHeaderStyle6Loaded) return;
  window.SusucarHeaderStyle6Loaded = true;

  function closePanel(panel, restoreFocus) {
    if (!panel || panel.hidden) return;

    panel.hidden = true;
    var trigger = document.querySelector('[data-susu-panel-trigger="' + panel.id + '"]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) trigger.focus();
    }
  }

  function closeAllPanels(exceptPanel) {
    document.querySelectorAll('[data-susu-header-panel]').forEach(function (panel) {
      if (panel !== exceptPanel) closePanel(panel, false);
    });
  }

  function togglePanel(trigger) {
    var panelId = trigger.getAttribute('data-susu-panel-trigger');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    var shouldOpen = panel.hidden;
    closeAllPanels(panel);
    panel.hidden = !shouldOpen;
    trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  }

  function closeDesktopMenu(menu) {
    if (!menu) return;
    menu.classList.remove('active');
    var trigger = menu.querySelector(':scope > .wrapper');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function toggleDesktopMenu(trigger) {
    var menu = trigger.closest('#header-second-nav');
    if (!menu) return;
    var shouldOpen = !menu.classList.contains('active');
    menu.classList.toggle('active', shouldOpen);
    trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  }

  function collectRoots(root, roots) {
    roots.push(root);
    var elements = root.querySelectorAll ? root.querySelectorAll('*') : [];
    elements.forEach(function (element) {
      if (element.shadowRoot) collectRoots(element.shadowRoot, roots);
    });
  }

  function isVisible(element) {
    if (!element || typeof element.getBoundingClientRect !== 'function') return false;
    var rect = element.getBoundingClientRect();
    var styles = window.getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden';
  }

  function findInboxLauncher() {
    var roots = [];
    collectRoots(document, roots);

    var selectors = [
      'shopify-chat button',
      '#ShopifyChat button',
      '[data-shopify-inbox] button',
      '[id*="shopify-chat" i] button',
      '[class*="shopify-chat" i] button',
      'shopify-chat',
      '#ShopifyChat',
      '[data-shopify-inbox]'
    ];

    for (var rootIndex = 0; rootIndex < roots.length; rootIndex += 1) {
      for (var selectorIndex = 0; selectorIndex < selectors.length; selectorIndex += 1) {
        var candidates = roots[rootIndex].querySelectorAll(selectors[selectorIndex]);
        for (var candidateIndex = 0; candidateIndex < candidates.length; candidateIndex += 1) {
          if (isVisible(candidates[candidateIndex])) return candidates[candidateIndex];
        }
      }
    }

    var labelPattern = /(chat|assistance|contact|help|support|live chat|message us)/i;
    for (var labelRootIndex = 0; labelRootIndex < roots.length; labelRootIndex += 1) {
      var buttons = roots[labelRootIndex].querySelectorAll('button, [role="button"]');
      for (var buttonIndex = 0; buttonIndex < buttons.length; buttonIndex += 1) {
        if (buttons[buttonIndex].closest && buttons[buttonIndex].closest('.header-style-6')) continue;
        var label = [
          buttons[buttonIndex].getAttribute('aria-label'),
          buttons[buttonIndex].getAttribute('title'),
          buttons[buttonIndex].textContent
        ].join(' ');
        if (labelPattern.test(label) && isVisible(buttons[buttonIndex])) return buttons[buttonIndex];
      }
    }

    return null;
  }

  function openInbox(button) {
    var panel = button.closest('[data-susu-header-panel]');
    closePanel(panel, false);

    var customEvent = new CustomEvent('susucar:shopify-inbox:open', {
      bubbles: true,
      cancelable: true,
      detail: { source: button }
    });
    if (!document.dispatchEvent(customEvent)) return;

    var attempts = 0;
    var status = panel ? panel.querySelector('[data-susu-inbox-status]') : null;
    var fallback = button.getAttribute('data-inbox-fallback');

    function tryOpen() {
      var launcher = findInboxLauncher();
      if (launcher && launcher !== button) {
        launcher.click();
        return;
      }

      attempts += 1;
      if (attempts < 5) {
        window.setTimeout(tryOpen, 250);
        return;
      }

      if (fallback) {
        window.location.assign(fallback);
        return;
      }

      if (status) {
        status.textContent = 'Live chat is currently unavailable. Please call or email us.';
        status.hidden = false;
        panel.hidden = false;
      }
    }

    tryOpen();
  }

  document.addEventListener('click', function (event) {
    var mobileDirectLink = event.target.closest('[data-susu-mobile-direct-link]');
    if (!mobileDirectLink) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(mobileDirectLink.href);
  }, true);

  document.addEventListener('click', function (event) {

    var desktopMenuTrigger = event.target.closest('#header-second-nav > .wrapper');
    if (desktopMenuTrigger) {
      event.preventDefault();
      toggleDesktopMenu(desktopMenuTrigger);
      return;
    }

    var panelTrigger = event.target.closest('[data-susu-panel-trigger]');
    if (panelTrigger) {
      event.preventDefault();
      if (panelTrigger.hasAttribute('data-susu-mobile-help')) {
        var drawer = panelTrigger.closest('.drawer');
        var drawerClose = drawer ? drawer.querySelector('.js-btn-close') : null;
        if (drawerClose) drawerClose.click();
        window.setTimeout(function () {
          togglePanel(panelTrigger);
        }, 180);
      } else {
        togglePanel(panelTrigger);
      }
      return;
    }

    var closeButton = event.target.closest('[data-susu-panel-close]');
    if (closeButton) {
      event.preventDefault();
      closePanel(closeButton.closest('[data-susu-header-panel]'), true);
      return;
    }

    var inboxButton = event.target.closest('[data-susu-inbox-trigger]');
    if (inboxButton) {
      event.preventDefault();
      openInbox(inboxButton);
      return;
    }

    if (!event.target.closest('.susu-header-menu')) closeAllPanels();
    if (!event.target.closest('#header-second-nav')) closeDesktopMenu(document.getElementById('header-second-nav'));
  });

  document.addEventListener('keydown', function (event) {
    var desktopMenuTrigger = event.target.closest && event.target.closest('#header-second-nav > .wrapper');
    if (desktopMenuTrigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      toggleDesktopMenu(desktopMenuTrigger);
      return;
    }
    if (event.key !== 'Escape') return;
    var openPanel = document.querySelector('[data-susu-header-panel]:not([hidden])');
    if (openPanel) closePanel(openPanel, true);
    closeDesktopMenu(document.getElementById('header-second-nav'));
  });

})();
